import Logger from '.';

export default {
  install(Vue, { logger }) {
    Vue.prototype.$logger = logger || new Logger();
  },
};
